<template>
  <v-footer
    id="core-footer"
    bottom fixed 
    height="52"
  >
    <div class="footer-items">
      <v-img v-if='showLogo' src='/img/logo.png'/>
      <!--span
        v-for="link in links"
        :key="link.name"
      >
        <a
          :href="link.Link"
          class="tertiary--text footer-links">{{ link.name }}</a>
      </span-->
    </div>
    <v-spacer/>
    <span class="font-weight-light copyright">
      &copy;
      {{ (new Date()).getFullYear() }}
      <a
        href="https://www.qualitygroup.it/"
        target="_blank">QualityGroup</a>, made with
      <v-icon
        color="tertiary"
        size="17">mdi-heart</v-icon>
      for a better world
    </span>
  </v-footer>
</template>

<script>
export default {
  props: {
    showLogo: { type: Boolean, deafult: false }
  },
  data: () => ({
  })
}
</script>

<style>
#core-footer {
  z-index: 0;
  background-color:#E7E7E7;
}
</style>
